import getClientConfigBuilder from '@apphiveio/controlsmanager/shared/getClientConfigBuilder'

export default getClientConfigBuilder(() => require('./client.config.json'))
